import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import appSelectors from '@/redux/app/appSelectors';

import useMatchMedia from '@/hooks/useMatchMedia';

import RightIcon from '@/images/right.svg?react';
import CloseIcon from '@/images/close.svg?react';

import Portal from '@/ui/portal';

import Nav from '../nav';

import s from './menu.module.css';

const ACC_URL = import.meta.env.VITE_ACC_URL;

function Menu({ close }) {
  const i18n = useSelector(appSelectors.translation);
  const lang = useSelector(appSelectors.language);
  const refCode = useSelector(appSelectors.refCode);

  const [opened, setOpened] = useState(false);

  const handleClick = () => {
    setOpened(false);
    setTimeout(() => {
      close();
    }, 300);
  };

  useEffect(() => {
    setOpened(true);
  }, []);

  const { isMobile } = useMatchMedia();

  const backdropStyles = opened ? s.backdrop_active : s.backdrop;
  const modalStyles = opened ? s.modal_active : s.modal;

  const loginUrl = refCode
    ? `${ACC_URL}/login?lang=${lang}&ref=${refCode}`
    : `${ACC_URL}/login?lang=${lang}`;

  const signupUrl = refCode
    ? `${ACC_URL}/signup?lang=${lang}&ref=${refCode}`
    : `${ACC_URL}/signup?lang=${lang}`;

  return (
    <Portal>
      <div className={backdropStyles} onClick={handleClick}>
        <div className={modalStyles} onClick={e => e.stopPropagation()}>
          <div className={s.menu_header}>
            {isMobile && (
              <a
                href={loginUrl}
                target="_blank"
                rel="noopener noreferrer"
                onClick={handleClick}
                className={s.btn_login}
              >
                {i18n.вход}
                <RightIcon />
              </a>
            )}

            {isMobile && (
              <a
                href={signupUrl}
                target="_blank"
                rel="noopener noreferrer"
                onClick={handleClick}
                className={s.btn_signup}
              >
                {i18n.регистрация}
              </a>
            )}

            <button
              type="button"
              onClick={handleClick}
              className={s.btn_close}
              title="close"
            >
              <CloseIcon />
            </button>
          </div>

          <Nav closeMenu={handleClick} />
        </div>
      </div>
    </Portal>
  );
}

export default Menu;

Menu.propTypes = {
  close: PropTypes.func.isRequired,
};
